<template>
    <div class="col-md-12">
        <!-- <div class="card">
            <div class="card-header">
                <b-row>
                    <b-col>
                    <h4> Notas Disponíveis para Devolução </h4>
                    </b-col>
                    <b-col style="text-align: right;">
                        <button class="btn btn-primary" @click="devolucoes">
                            Devoluções Solicitadas
                        </button>
                    </b-col>
                </b-row>
            </div>
            <div class="card-body">
                <v-table :column="colunas" :data="dataComputed" :actions="actionsTable" @show="show" v-if="!modalVisible"></v-table>
            </div>
        </div> -->
        
        <v-table :column="colunas" :data="dataComputed" :actions="actionsTable" @show="show" v-if="!modalVisible"></v-table>

        <!---------------- Modal Devolução ---------------------->
        <b-modal v-model="modalDevolve" title="Solicitar Devolução" size="xl">
            <b-card>
                <ul class="text-danger">
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                    <!--<flash></flash> -->
                    <input type="hidden" v-model="danfe_id" />
                    <input type="hidden" v-model="chave" />
                    <input type="hidden" v-model="revendedora_id" />
                </ul>
                <div class="row">
                    <div class="col-md-4">
                        <h5>Revendedora</h5>
                    </div>
                    <div class="col-md-6">
                        <span>{{ danfe.nome }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <h5>Chave da Nota</h5>
                    </div>
                    <div class="col-md-6">
                        <span>{{ danfe.chave }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <h5>Número da Nota</h5>
                    </div>
                    <div class="col-md-6">
                        <span>{{ danfe.numero }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Tipo Devolução:</label>
                            <select class="form-control" v-model="tipo" id="tipo-devolve">
                                <option :value="3">Extravio / Perda</option>
                                <!-- <option :value="2">Parcial</option>-->
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Tipo de Frete:</label>
                            <select class="form-control" v-model="frete" id="tipo-frete">
                                <option :value="1">Proprio</option>
                                <option :value="2">Coleta</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Justificativa:</label>
                            <textarea class="form-control" rows="2" cols="3" v-model="justificativa" placeholder="Digite aqui a sua o motivo da sua devolução"></textarea>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Adicionar uma imagem:</label>
                            <!--<b-form-file :name="image" v-model="addFile" placeholder="Nenhuma imagem selecionada" browse-text="Selecionar"></b-form-file> -->
                            <input type="file" v-on:change="addFile" :name="image" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group" v-if="tipo == 2">
                        <table class="table table-responsive">
                            <thead>
                                <th>Selecione...</th>
                                <th>Produto</th>
                                <th>Descricao</th>
                                <th>Quantidade</th>
                            </thead>
                            <tbody>
                                <tr v-for="itens in danfe.itens" :key="itens">
                                    <td>
                                        <input type="checkbox" class="form-control" name="itens[]" @click="markDevolucao(itens.id)" />
                                    </td>
                                    <td>
                                        {{ itens.produto }}
                                    </td>
                                    <td>
                                        {{ itens.descricao }}
                                    </td>
                                    <td>
                                        {{ itens.quantidade }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </b-card>
            <template #modal-footer>
                <b-button @click="salvaDevolucao" variant="primary" size="sm" id="botao-salvar"><i class="fas fa-undo-alt"></i> Devolver</b-button>
                <b-button variant="danger" size="sm" @click="reset">
                    Cancelar
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
// import InputFile from "../../util/InputFile";
export default {
    components: {
        // InputFile
    },
    data() {
        return {
            datePickerConfig: {
                format: "D/MM/YYYY",
                showClose: true,
            },
            modalVisible: false,
            modalDevolve: false,
            search: "",
            colunas: [
                ["Cod.", "codrevendedora"],
                ["Pedido", "pedido"],
                ["Lote", "lote"],
                ["Revendedora", "revendedora"],
                ["Número NF", "numero"],
                ["Data Emissão", "emissao"],
                ["Data Limite Devolução", "limite"],
                ["Total R$", "total"],
            ],
            tableAttr: ["numero", "revendedora"],
            data: [],
            actionsTable: ["show"],
            tipo: 1,
            frete: 0,
            file: "",
            attachment: {},
            justificativa: "",
            revendedora_id: 0,
            itensDevolve: [],
            danfe_id: 0,
            image: "",
            chave: 0,
            existeDevolucao: 0,
            danfe: {
                numero: 0,
                chave: 0,
                tipo: "",
                valor: "",
                itens: [],
                pedidos: 0,
                revendedora: 0,
            },
            errors: [],
        };
    },
    computed: {
        filteredData() {
            return this.data.filter((item) => {
                return (
                    item.revendedora.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                );
            });
        },
        dataComputed() {
            console.log(this.data)
            return this.data;
        },
    },
    methods: {
        devolucoes() {
            $(".loading").show();
            window.location.href = "/distribuidor/devolucao/acompanhar";
        },
        addFile(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => {
                this.image = e.target.result;
            };

            reader.readAsDataURL(file);
            this.$emit("input", file);
        },
        showLoading() {
            $(".loading").show();
        },
        loadData() {
            $(".loading").show();
            var vm = this;
            axios
                .get("/distribuidor/devolucao/listar")
                .then(function (response) {
                    vm.formatDataToTable(response.data.danfe, response.data.cd);
                    $(".loading").hide();
                })
                .catch(function (errors) {
                    console.log(errors);
                    $(".loading").hide();
                });
        },
        formatDataToTable(dataLoaded, cd) {
            var data = [];

            dataLoaded.forEach(function (el, index) {
                let obj = {};
                obj.id = el.id;
                obj.revendedora = el.nome;
                obj.pedido = el.pedido;
                obj.lote = el.lote;
                obj.codrevendedora = el.revendedora_codigo;
                obj.numero = el.numero;
                obj.emissao = new Date(el.emissao_nf).toLocaleDateString();
                if (cd == 12) {
                    if (el.prazo_devolucao) {
                        obj.limite = moment(el.vencimento).format("DD/MM/Y");
                    } else {
                        obj.limite = moment(el.vencimento).add(cd, "days").format("DD/MM/Y");
                    }
                } else {
                    obj.limite = moment(el.emissao_nf).add(cd, "days").format("DD/MM/Y");
                }

                obj.total = el.titulo.toLocaleString("pt-BR").replace(".", ",");

                data.push(obj);
            });

            this.data = data;
        },

        show(id) {
            var vm = this;
            var ob1 = [];

            $(".loading").show();
            axios
                .get("/distribuidor/devolucao/danfe/" + id)
                .then(function (response) {
                    let revendedor = response.data;

                    revendedor.forEach(function (a, b) {
                        vm.danfe.nome = a.pedidos.revendedora.nome;
                        vm.danfe.numero = a.numero;
                        vm.danfe.chave = a.chave;
                        vm.danfe.titulo = a.titulo;
                        vm.danfe.revendedora = a.pedidos.revendedora_id;
                        vm.danfe_id = a.id;
                        vm.revendedora_id = a.pedidos.revendedora.id;
                        vm.chave = a.chave;
                        vm.danfe.lote = a.lote;
                        ob1 = a.itens;
                    });
                    //---------------------------------------------------CARREGA OS ITENS DA DANFE --------
                    ob1.forEach(function (c, d) {
                        let obj = {};
                        obj.produto = c.produto.codigo;
                        obj.descricao = c.produto.nome;
                        obj.quantidade = c.quantidade;
                        obj.danfe_id = c.danfe_id;
                        obj.id = c.id;

                        vm.danfe.itens.push(obj);
                    });

                    $(".loading").hide();
                    vm.modalDevolve = true;
                    //$("#modal-Devolve").modal();
                })
                .catch(function (errors) {
                    console.log(errors);
                    $(".loading").hide();
                });
        },
        salvaDevolucao() {
            var vm = this;
            if (this.danfe.danfe_id == 0) {
                alert("Erro ao Selecionar a Nota fiscal. Tente novamente", "error");
                $(".loading").hide();
                return;
            }
            if (this.tipo == 0) {
                alert("Por favor, Selecione o Tipo de devolução", "error");
                $("#tipo-devolve").focus();
                $(".loading").hide();
                return;
            }
            if (this.frete == 0) {
                alert("Por Favor, Selecione o frete", "error");
                $("#tipo-frete").focus();
                $(".loading").hide();
                return;
            }
            if (this.justificativa.length < 5) {
                alert("Digite uma justificativa válida.", "error");
                $(".loading").hide();
                return;
            }
            if (this.tipo == 2) {
                if (this.itensDevolve.length <= 0) {
                    alert("Para devolução parcial é preciso informar os itens.", "error");
                    $(".loading").hide();
                    return;
                }
            }

            let url = "/distribuidor/devolucao/salva";
            let TipoDevolucao = "";
            let TipoFrete = "";
            if (this.tipo == 2) {
                TipoDevolucao = "PARCIAL";
            }else if(this.tipo == 3){
                TipoDevolucao = "EXTRAVIO"
            } else {
                TipoDevolucao = "TOTAL";
            }
            if (this.frete == 1) {
                TipoFrete = "PROPRIO";
            } else {
                TipoFrete = "COLETA";
            }
            var data = {
                danfe: this.danfe_id,
                revendedora_id: this.revendedora_id,
                tipo: TipoDevolucao,
                justificativa: this.justificativa,
                chave: this.chave,
                frete: TipoFrete,
                image: this.image,
                itens: this.itensDevolve,
                lote: this.danfe.lote,
            };
            this.$swal({
                title: 'Realmente deseja solicitar a devolução da Nota Fiscal '+  vm.danfe.numero +'?',
                text: 'Esta ação não poderá ser revertida!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, Solicitar!',
                cancelButtonText: 'Não, cancelar!',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    $(".loading").show();
                    axios
                        .post(url, data)
                        .then(function (response) {
                            console.log(response.data);
                            $(".loading").hide();                           
                            //$("#createModal").modal("hide");
                            //window.location.href = "/distribuidor/devolucao";
                            vm.loadData();
                            vm.reset();
                        })
                        .catch(function (error) {
                            var errors = error.response.data.error;
                            if (typeof errors == "object") {
                                console.log(errors);
                                alert(errors);
                            } else {
                                alert(errors);
                            }
                            $(".loading").hide();
                        });
                }
            })
        },

        fechar() {
            this.modalVisible = !this.modalVisible;
        },
        reset() {
          this.modalDevolve = false;
            this.danfe = {
                numero: 0,
                chave: 0,
                tipo: "",
                valor: "",
                itens: [],
                pedidos: 0,
                revendedora: 0,
            };
            this.tipo = 1;
            this.frete = 0;
            this.file = "";
            this.justificativa = "";
            this.chave = "";
            this.danfe_id = 0;
            this.revendedora_id = 0;
        },
        markDevolucao(id) {
            var vm = this;
            var indices = [];
            var idx = vm.itensDevolve.indexOf(id);

            if (idx === -1) {
                vm.itensDevolve.push(id);
                console.log("adicionado a variavel.." + id);
                console.log("resultado..." + vm.itensDevolve);
            } else {
                vm.itensDevolve.splice(idx);
                console.log("Removido a variavel.." + id);
                console.log("resultado..." + vm.itensDevolve);
            }
        },
    },
    mounted() {
        this.loadData();
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_devolucao/DevolucaoAdm.vue